export enum EOpenPoseBodyBone {
  /*
   * ARMS
   */
  FOREARM_LEFT = 'elbow_left_link_wrist_left',
  FOREARM_RIGHT = 'elbow_right_link_wrist_right',

  SHOULDER_LEFT = 'neck_link_shoulder_left',
  SHOULDER_RIGHT = 'neck_link_shoulder_right',

  UPPER_ARM_LEFT = 'shoulder_left_link_elbow_left',
  UPPER_ARM_RIGHT = 'shoulder_right_link_elbow_right',

  /*
   * HEAD
   */
  EYE_TO_EAR_LEFT = 'eye_left_link_ear_left',
  EYE_TO_EAR_RIGHT = 'eye_right_link_ear_right',

  NECK_TO_NOSE = 'neck_link_nose',

  NOSE_TO_EYE_LEFT = 'nose_link_eye_left',
  NOSE_TO_EYE_RIGHT = 'nose_link_eye_right',

  /*
   * LEGS
   */
  LOWER_LEG_LEFT = 'knee_left_link_ankle_left',
  LOWER_LEG_RIGHT = 'knee_right_link_ankle_right',

  THIGH_LEFT = 'neck_link_hip_left',
  THIGH_RIGHT = 'neck_link_hip_right',

  UPPER_LEG_LEFT = 'hip_left_link_knee_left',
  UPPER_LEG_RIGHT = 'hip_right_link_knee_right',
}
